import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/userservice/api/menu/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/userservice/api/menu/detail',
    method: 'post',
    data: data
  });
}
export function fetchDelete(menuIds) {
  var data = {
    menuIds: menuIds
  };
  return request({
    url: '/userservice/api/menu/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/userservice/api/menu/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/userservice/api/menu/update',
    method: 'post',
    data: data
  });
}
export function fetchTreeList(data) {
  return request({
    url: '/userservice/api/menu/tree',
    method: 'post',
    data: data
  });
} // 已选中

export function fetchChooseList(data) {
  return request({
    url: '/pmsservice/api/sysInterface/chooseList',
    method: 'post',
    data: data
  });
} // 未选中

export function fetchNotChooseList(data) {
  return request({
    url: '/pmsservice/api/sysInterface/notChooseList',
    method: 'post',
    data: data
  });
} // 保存

export function updateMenuRelation(data) {
  return request({
    url: '/pmsservice/api/sysInterface/updateMenuRelation',
    method: 'post',
    data: data
  });
}